import { useQuery } from '@tanstack/react-query';

import { fetchTableViewColumns } from '../data-provider/table-view-columns';

export interface TableViewColumn {
  columnName: string;
  columnValue: string;
  id?: string;
}

export const useGetTableViewColumns = (gridName = 'LossAndDamageClaims') => {
  return useQuery({
    queryFn: () => fetchTableViewColumns({ GridName: gridName }),
    queryKey: ['claims-loss-and-damage-table-view-columns', gridName],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
